import React from 'react';
import Header from './Header';
import Home from './Home';
import Checkout from './Checkout';
import Login from './Login';
//router

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';


import './App.css';

function App() {
  return (
    //BEM syntax




    <Router>
      <div className="container-fluid m-0 p-0">
        {/*<h1>Hello from Mangya Ecomm 🚀  </h1>*/}
        {/*header section*/}
        {/*Home Section*/}

        <Header />

        <Switch>

          <Route path="/login">

            <Login />
          </Route>



          <Route path="/checkout">

            {/* <h1>Welcome To CheckOut Page! 🤑 </h1> */}
            <Checkout />

          </Route>




          <Route path="/">

            <Home />
          </Route>




        </Switch>

      </div>
    </Router>


  );
}

export default App;
